import React from "react";
import { motion } from "framer-motion";
import Countdown from "./Countdown";
import { COUPLE_NAME, WEDDING_DATE, WEDDING_DATE_DISPLAY, WEDDING_LOCATION } from "../config";

export default function HeroSection() {
  return (
    <section id="welcome" className="relative h-screen flex items-center justify-center text-white">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: "url('/Images/Welcome/Welcome_background.png')",
        }}
      />
      <div className="absolute inset-0 bg-amber-900 bg-opacity-40" />

      <motion.div
        className="relative z-10 text-center px-4"
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1.2, ease: "easeOut" }}
      >
        <h2 className="text-5xl md:text-6xl mb-4">{COUPLE_NAME}</h2>
        <p className="text-xl md:text-2xl mb-6">
          {WEDDING_DATE_DISPLAY} – {WEDDING_LOCATION}
        </p>
        <Countdown targetDate={WEDDING_DATE} />
        <motion.a
          href="#rsvp"
          onClick={(e) => {
            e.preventDefault();
            const section = document.getElementById("rsvp");
            if (section) {
              section.scrollIntoView({ behavior: "smooth", block: "start" });
            }
          }}
          className="mt-8 inline-block font-bold text-lg font-garamond small-caps border-2 border-amber-700 bg-white/85 text-amber-700 px-8 py-3 rounded-full shadow-lg hover:bg-amber-700 hover:text-white hover:border-white/60 transition"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.5, duration: 0.8 }}
        >
          Confirm Attendance
        </motion.a>
      </motion.div>
    </section>
  );
}
